import { useFormikContext } from 'formik';

import Button from '../../Button';
import React from 'react';
import {
  AnyAssetApplication,
  AssetParams,
  Connections,
  FormikNewFormValues,
  useAssetConfig,
  useAssetParams,
  useAssetTranslation,
} from '@mss/mss-component-library';

type Props = {
  onClick: () => void;
  index?: number;
  overrideAssetParams?: Partial<AssetParams>;
  disabled?: boolean;
};
const ContinueFailedTestButton = ({
  onClick,
  index,
  overrideAssetParams,
  disabled,
}: Props) => {
  const { values } =
    useFormikContext<FormikNewFormValues<AnyAssetApplication>>();
  const { assetSubType } = useAssetParams(overrideAssetParams);
  const { matchingConfig } = useAssetConfig<AnyAssetApplication>(assetSubType);
  const { t } = useAssetTranslation();
  const shouldShow = values.assets.reduce((acc, asset, i) => {
    if (index != null && i !== index) return acc;
    const connectionTypes = Object.keys(matchingConfig.form.connect) as [
      keyof Connections,
    ];

    const testRan = connectionTypes.some(
      key => asset[`test_${key}`].result.status.port !== null
    );
    const testFailed = connectionTypes.some(key =>
      Object.values(asset[`test_${key}`].result.status).includes(false)
    );

    return testRan && testFailed;
  }, false);

  if (!shouldShow) return null;
  return (
    <Button
      ghost
      onClick={onClick}
      disabled={disabled}
      colorOverrides={{
        text: '#fa4654',
        border: '#fa4654',
      }}
      className="mr-2"
      data-ta="saveCredentialsFailedTestButton"
    >
      {t('Continue despite failed tests')}
    </Button>
  );
};

export default ContinueFailedTestButton;
